import * as React from 'react';
import { Link } from 'react-router-dom';
import playerPlaceholder from '../assets/player-placeholder.svg';
import {
  getPlayerPhotoUrl,
  formatMetricValue,
  PLAYER_CARD_METRICS,
} from '../custom/playerViewModel';
import { isPlayerActive } from '../custom/dashboardData';

const birthYearText = (player) => (player.birthYear ? `${player.birthYear} г.р.` : 'Год рождения не указан');

const AdminPlayerCard = ({ player }) => {
  const photo = getPlayerPhotoUrl(player) || playerPlaceholder;
  const active = isPlayerActive(player.Active);

  return (
    <Link className="fs-dashboard-player-card" to={`/footballers/${player.id}`}>
      <div className="fs-dashboard-player-card__photo-wrap">
        <img
          src={photo}
          alt={[player.lastname, player.firstname].filter(Boolean).join(' ') || 'Футболист'}
          onError={(event) => {
            if (event.currentTarget.src !== playerPlaceholder) event.currentTarget.src = playerPlaceholder;
          }}
        />
        <span className={`fs-player-card-status ${active ? 'is-active' : 'is-inactive'}`}>
          {active ? 'Активный' : 'Неактивный'}
        </span>
      </div>

      <div className="fs-dashboard-player-card__body">
        <div className="fs-dashboard-player-card__identity">
          <div>
            <h3>{player.lastname || 'Без фамилии'}</h3>
            <p>{player.firstname || 'Имя не указано'}</p>
          </div>
          <span>{birthYearText(player)}</span>
        </div>

        <div className="fs-dashboard-player-card__meta">
          <strong>{player.team || 'Команда не указана'}</strong>
          <span>{player.playerPosition || 'Позиция не указана'}</span>
        </div>

        <div className="fs-dashboard-player-card__metrics">
          {PLAYER_CARD_METRICS.map(({ key, label }) => (
            <div className="fs-player-metric" key={key}>
              <span className="fs-player-metric__label">{label}</span>
              <strong>{formatMetricValue(key, player.bestMetrics?.[key])}</strong>
              <small>
                {Number.isFinite(player.cohortAverages?.[key])
                  ? `ср. ${formatMetricValue(key, player.cohortAverages[key])}`
                  : 'ср. —'}
              </small>
            </div>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default AdminPlayerCard;
